import { useState } from 'react';
import { Copy, Check } from 'lucide-react';

interface Props {
  value: string;
  className?: string;
  iconSize?: number;
  display?: React.ReactNode; // override display text/element
  silent?: boolean;          // suppress the "Copied" tick (use sparingly)
}

/** Small inline copy-to-clipboard button next to an identifier (AWB / LR / order no). */
export function CopyText({ value, className = '', iconSize = 12, display, silent }: Props) {
  const [done, setDone] = useState(false);

  const doCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!value) return;
    navigator.clipboard?.writeText(value).then(() => {
      setDone(true);
      setTimeout(() => setDone(false), 1200);
    }).catch(() => {});
  };

  return (
    <span className={`inline-flex items-center gap-1 ${className}`}>
      <span>{display ?? value}</span>
      {value ? (
        <button onClick={doCopy} title={done ? 'Copied!' : 'Copy'}
          className={`p-0.5 rounded ${done ? 'text-emerald-600' : 'text-slate-400 hover:text-primary'} transition`}>
          {done && !silent ? <Check size={iconSize} /> : <Copy size={iconSize} />}
        </button>
      ) : null}
    </span>
  );
}
